import React, { useState, useEffect, useCallback } from 'react';

interface CountdownProps {
  targetDate: string; // Target date in ISO format (e.g., "2024-12-25T00:00:00")
}

const Countdown: React.FC<CountdownProps> = ({ targetDate }) => {
  const calculateTimeLeft = useCallback(() => {
    const difference = new Date(targetDate).getTime() - new Date().getTime();
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }, [targetDate]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer); // Cleanup on component unmount
  }, [calculateTimeLeft, targetDate]);

  return (
    <div className="flex flex-row gap-4 justify-center items-center">
      <CountdownBox title="Days">{timeLeft.days}</CountdownBox>
      <CountdownBox title="Hours">{timeLeft.hours}</CountdownBox>
      <CountdownBox title="Minutes">{timeLeft.minutes}</CountdownBox>
      <CountdownBox title="Seconds">{timeLeft.seconds}</CountdownBox>
    </div>
  );
};

interface CountdownBoxProps {
  children: string | number;
  title: string;
}

const CountdownBox = ({ children, title }: CountdownBoxProps) => {
  return (
    <div className="bg-slate-300 aspect-square p-8 flex-1 flex flex-col justify-center items-center max-h-48">
      <div className="flex-1 flex justify-center items-center text-4xl font-bold">
        {children}
      </div>
      <div>{title}</div>
    </div>
  );
};

export default Countdown;
